module.exports = __webpack_public_path__ + "img/endbut.d21ded78.png";